import PropTypes from 'prop-types';
import CreateEditModal from 'common/components/modules/modal-wrapper';
import MethodsWrapperByTypes from './modules/methods-wrapper-by-types'
import { useEffect } from 'react';

const AvailablePaymentMethodsModal = ({
   avaliablePaymentMethods,
   onCloseModal,
   isMobile,
   isNextApp,
   defaultCandidatePaymentOptions,
   primaryColor,
   showOptionsType = '',
   onAddModalQuery,
   onRemoveModalQuery,
}) => {
   const CREDIT_CARD_METHODS = ['visa_card', 'master_card', 'maestro_card', 'visa_debit', 'debit', 'jcb_card', 'discover_card', 'diners_club_international_card']
   const CRYPTO_METHODS = ['crypto', 'segpay_crypto']

   const isShowCreditCards = avaliablePaymentMethods.some(methodType => CREDIT_CARD_METHODS.includes(methodType))
   const isShowPayByBank = avaliablePaymentMethods.includes('pay_by_bank')
   const isShowCriptoPayments = avaliablePaymentMethods.some(methodType => CRYPTO_METHODS.includes(methodType))
   const isShowPaypal = avaliablePaymentMethods.includes('segpay_paypal')

   const METHODS_WRAPPER_BY_TYPES_BASE_PROPS = {
      avaliablePaymentMethods: avaliablePaymentMethods,
      isNextApp: isNextApp,
      defaultCandidatePaymentOptions: defaultCandidatePaymentOptions,
      primaryColor: primaryColor,
      showOptionsType,
   }

   useEffect(() => {
      if(onAddModalQuery) {
         onAddModalQuery()
      }
      return () => {
         if(onRemoveModalQuery) {
            onRemoveModalQuery()
         }
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return (
      <CreateEditModal
         type='confirm'
         onCloseModal={ onCloseModal }
         isMobile={ isMobile }
         isPreventDeafault={ false }
         iconSize='2xl'
         icon='payment-card'
         title='Available payment methods'
         withoutCloseButton={ false }
         withoutCancelButton
         withoutConfirmButton
         contentWidth='560px'
         isScrollableTopPartWithoutButtons
      >
         <div
            className='w-full mt-6 flex flex-col rounded-lg border border-divider dark:border-divider-dark p-1 text-start mb-[1px]'
         >
            {
               isShowCreditCards && (
                  <MethodsWrapperByTypes
                     type='credit_cards'
                     { ...METHODS_WRAPPER_BY_TYPES_BASE_PROPS }
                  />
               )
            }
            {
               isShowPayByBank && (
                  <MethodsWrapperByTypes
                     type='pay_by_bank'
                     { ...METHODS_WRAPPER_BY_TYPES_BASE_PROPS }
                  />
               )
            }
            {
               isShowCriptoPayments && (
                  <MethodsWrapperByTypes
                     type='crypto'
                     { ...METHODS_WRAPPER_BY_TYPES_BASE_PROPS }
                  />
               )
            }
            <MethodsWrapperByTypes
               type='mms_wallet'
               { ...METHODS_WRAPPER_BY_TYPES_BASE_PROPS }
            />
            {
               isShowPaypal && (
                  <MethodsWrapperByTypes
                     type='paypal'
                     { ...METHODS_WRAPPER_BY_TYPES_BASE_PROPS }
                  />
               )
            }
         </div>
      </CreateEditModal>
   )
}

AvailablePaymentMethodsModal.propTypes = {
   avaliablePaymentMethods: PropTypes.bool,
   onCloseModal: PropTypes.func,
   isMobile: PropTypes.bool,
   isNextApp: PropTypes.bool,
   defaultCandidatePaymentOptions: PropTypes.object,
   primaryColor: PropTypes.string,
   showOptionsType: PropTypes.string,
   onAddModalQuery: PropTypes.func,
   onRemoveModalQuery: PropTypes.func,
}

export default AvailablePaymentMethodsModal;
